import React, { useContext, useEffect } from 'react'
import { GeneralContext } from '../../context/'
import {
    Container,
} from "reactstrap"

import Form from './components/Form'
import { withRouter } from 'react-router-dom'

const Create = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setBreadcrumb } = generalContext

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Clientes`,
            parentLink: '/customers',
            item: `Nuevo Cliente`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form {...props} />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Create)